import React from 'react';
import styled from 'styled-components';
import history from '../../utils/history';

const IMG_LIT = require('../../images/lit.png');

const TemplateContainer = styled.div`
  overflow: hidden;
  
  #pagamento-page {
    padding-top: 0;
    margin-top: 0;
  }
  
  @media (max-width: 768px) {
    #pagamento-page {
      padding: 0;
    }
  }
`;

const NavLit = styled.nav`
  background-image: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    background: none;
    /* padding: 0; */
    margin: 0;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    &:hover {
      text-decoration: underline;
    }
  }
`;

function logout() {
  history.push('/logout');
}

const Template = ({ havePlan, children, showHeader = false }) => (
  <TemplateContainer id="pagamento">
    {havePlan && (
      <div className="aviso">
        <h5>
          Seu período trial expirou, você precisa realizar o pagamento para
          continuar tendo acesso a todo o conteúdo do LIT
        </h5>
      </div>
    )}
    {showHeader && (
      <NavLit className="navbar navbar-lit navbar-expand-lg bg-gradient-lit">
        <a className="navbar-brand">
          <img src={IMG_LIT} alt="logo_lit" style={{ width: '100px' }} />
        </a>
        <button type="button" onClick={() => logout()}>
          SAIR
        </button>
      </NavLit>
    )}
    <div className="container" style={{ maxWidth: 1370, paddingTop: showHeader ? '20px' : '0' }}>
      <div className="row">
        <div id="pagamento-page" className="col-md-12">
          {children}
        </div>
      </div>
    </div>
  </TemplateContainer>
);

export default Template;
